// Round THEME-2 (2026-10-03) — react-select that follows the dashboard theme.
//
// react-select paints its control, menu and options from its own `theme.colors`. Here those colours
// point at CSS variables with react-select's original colours as the fallbacks, so Light · Classic
// looks exactly as before and the other themes (appThemeSync.css, "--ssw-rs-*") recolour the
// control, the menu and the highlighted / selected options.
//
// Drop-in replacement:  import Select, { components } from "<path>/Components/Common/ThemedSelect";
import React from "react";
import Select, { components } from "react-select";

export { components };

export const sswSelectTheme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary: "var(--ssw-rs-primary, #2684FF)",
        primary75: "var(--ssw-rs-primary75, #4C9AFF)",
        primary50: "var(--ssw-rs-primary50, #B2D4FF)",
        primary25: "var(--ssw-rs-primary25, #DEEBFF)",
        neutral0: "var(--ssw-rs-bg, hsl(0, 0%, 100%))",
        neutral5: "var(--ssw-rs-n5, hsl(0, 0%, 95%))",
        neutral10: "var(--ssw-rs-n10, hsl(0, 0%, 90%))",
        neutral20: "var(--ssw-rs-n20, hsl(0, 0%, 80%))",
        neutral30: "var(--ssw-rs-n30, hsl(0, 0%, 70%))",
        neutral40: "var(--ssw-rs-n40, hsl(0, 0%, 60%))",
        neutral50: "var(--ssw-rs-n50, hsl(0, 0%, 50%))",
        neutral60: "var(--ssw-rs-n60, hsl(0, 0%, 40%))",
        neutral70: "var(--ssw-rs-n70, hsl(0, 0%, 30%))",
        neutral80: "var(--ssw-rs-n80, hsl(0, 0%, 20%))",
        neutral90: "var(--ssw-rs-n90, hsl(0, 0%, 10%))",
    },
});

// A selected option is drawn with the "neutral0" colour as its text, which is the dark background
// colour in a dark theme; give selected options their own readable text colour instead.
const withSelectedText = (styles) => ({
    ...styles,
    option: (base, state) => {
        const own = { ...base, color: state.isSelected ? "var(--ssw-rs-on-primary, hsl(0, 0%, 100%))" : base.color };
        return styles && styles.option ? styles.option(own, state) : own;
    },
});

const ThemedSelect = React.forwardRef(({ theme, styles, ...rest }, ref) => (
    <Select ref={ref} theme={theme || sswSelectTheme} styles={withSelectedText(styles)} {...rest} />
));
ThemedSelect.displayName = "ThemedSelect";

export default ThemedSelect;
